import { render } from "./CookieDetail.vue?vue&type=template&id=8092c6a2&ts=true"
import script from "./CookieDetail.vue?vue&type=script&lang=ts"
export * from "./CookieDetail.vue?vue&type=script&lang=ts"

import "./CookieDetail.vue?vue&type=style&index=0&id=8092c6a2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__